import { safeGet } from "@app/shared/utils/secure/safe-get";
import { createSelector } from "@ngrx/store";
import { selectDietTypeState } from "../reducers";
import * as fromDietType from "../reducers/diet-type.reducer";

export const selectDietTypeListIsLoading = () =>
  createSelector(selectDietTypeState(), fromDietType.selectIsLoading);

export const selectDietTypeEntities = () =>
  createSelector(selectDietTypeState(), fromDietType.selectDietTypeEntities);

export const selectAllDietTypes = () =>
  createSelector(selectDietTypeState(), fromDietType.selectAllDietTypes);

export const selectDietTypeById = (id: number) =>
  createSelector(selectDietTypeEntities(), (dietTypeEntities) =>
    safeGet(dietTypeEntities, String(id)),
  );
